import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <button
      onClick={scrollToTop}
      className={`tw-fixed tw-bottom-6 tw-right-6 tw-z-50 tw-p-3 tw-rounded-full tw-bg-affinicar-primary tw-text-white tw-shadow-lg hover:tw-bg-affinicar-secondary tw-transition-all tw-duration-300 ${
        visible ? 'tw-opacity-100 tw-translate-y-0' : 'tw-opacity-0 tw-translate-y-4 tw-pointer-events-none'
      }`}
      aria-label="Retour en haut"
    >
      <ChevronUp size={20} />
    </button>
  );
}
